export enum ProductSize {
  ORIGINAL = "ORIGINAL",
  DELUXE = "DELUXE",
  GRAND = "GRAND",
}

export enum ProductVolume {
  SIX_MONTHS = "MONTHS 6",
  ONE = "YEAR 1",
  THREE = "YEARS 3",
}

export enum ProductStatus {
  PAUSE = "PAUSE",
  PROCESS = "PROCESS",
  DELETE = "DELETE",
}

export enum ProductCollection {
  BOUQUET = "BOUQUET",
  VASE = "VASE",
  HOUSEPLANT = "HOUSEPLANT",
  TREE = "TREE",
  OTHER = "OTHER",
}

export enum ProductItemSize {
  FREE = "FREE",
  SMALL = "SMALL",
  NORMAL = "NORMAL",
  LARGE = "LARGE",
}
